import { useTranslation } from 'react-i18next'

export const useTitles = () => {
  const { t } = useTranslation()
  return {
    language: t('menu.language'),
    'data-deletion': t('menu.delete_data'),
    promo: t('menu.enter_promo_code'),
    'ton-wallet': t('menu.ton_wallet'),
    support: t('menu.support'),
    logout: t('menu.exit'),
  }
}
